






































import { Component, Vue } from "vue-property-decorator";
import { State, Getter } from "vuex-class";
import Transaction from "../models/transaction";
import TransactionListItem from "../components/TransactionListItem.vue";
import SwipeActions from "../components/SwipeList/SwipeActions.vue";
import dayjs from "dayjs";

@Component({
  components: {
    TransactionListItem,
    SwipeActions
  }
})
export default class TransactionList extends Vue {
  @Getter("orderedTransactions") private localTransactions!: Transaction[];
  @Getter public transactionDates!: string[];

  public transactionsInDate(date: string) {
    return this.localTransactions.filter((t) => t.dateString === date);
  }

  public async deleteTransaction(id: string) {
    await this.$store.dispatch('removeTransactionAsync', id);
  }

  public editTransaction(id: string) {
    this.$router.push(`/transactions/${id}`);
  }
}
